(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class Banner extends HTMLElement {
    constructor() {
    	super();
    }
    connectedCallback() {
      this.banner = document.getElementsByClassName('section--bannner')[0];
      if(window.innerWidth > 990){        
        this.banner.remove();
		 document.getElementById('MainContent').style.setProperty('padding-top', 0);
      }
    }
  }
  customElements.define('banner-hide', Banner);


  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
	  this.bar = document.getElementById('shopify-section-announcement-bar');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
	  	  
	  this.banner = document.querySelectorAll("#MainContent > .shopify-section:first-child .section--bannner").length;
	  this.bar_h = document.querySelectorAll('#shopify-section-announcement-bar').length;	  

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;	  

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false); 
     
	  //=== Sticky for Banner Only ===
	  this.header.classList.add('shopify-section-header-sticky');
	  
	setTimeout(() => {
	 document.querySelector('body').style.setProperty('--bar-height', `${parseInt(this.bar.getBoundingClientRect().height)}px`);

	  if(this.banner > 0) {this.header.classList.add('shopify-section-header-transparent');}
	  else{
this.header.classList.add('shopify-section-header-not-transparent');
	  //=== Height ====	  
      setTimeout(() => {
           document.querySelector('body').style.setProperty('--header-height', `${parseInt(this.header.getBoundingClientRect().height)}px`);	  
      }, 100);
	  }
	  }, 100);
	/*
	   window.addEventListener('resize', function(event){
		this.header = document.getElementById('shopify-section-header');
		  document.querySelector('body').style.setProperty('--header-height', `${parseInt(this.header.getBoundingClientRect().height)}px`);	  
		});
*/

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header, this.banner);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	  

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      //this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	  this.header.classList.add('shopify-section-header-sticky', 'animate');
	  if(this.banner > 0) {
	  this.header.classList.remove('shopify-section-header-transparent');
		this.header.classList.add('shopify-section-header-not-transparent');
	  }
	  if(this.bar_h > 0){
		this.bar.style.setProperty('top', `${(parseInt(this.bar.getBoundingClientRect().height) + 1) * -1}px`);
		this.header.style.setProperty('top', `${(parseInt(this.bar.getBoundingClientRect().height) + 1) * -1}px`);
	  }
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
     // this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      //this.header.classList.remove('shopify-section-header-hidden', 'animate');
	if(this.bar_h > 0){
		this.bar.style.setProperty('top', '0px');
		this.header.style.setProperty('top', '0px');		
	  }
	if(this.banner > 0) {
      this.header.classList.add('shopify-section-header-transparent');
		this.header.classList.remove('shopify-section-header-not-transparent');
	}
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
      })();
